import React from 'react';

const MarqueeSectionS2 = (props) => {

    return (
        <div className="animate-marque-sec-s2 section-padding pt-0">
            <div className="animate-marque">
                <div className="marquee">
                    <div className="track">
                        <div className="content">
                            <h1>
                                <span>Logo</span> <i>.</i>
                                <span>Branding</span> <i>.</i>
                                <span>Innovation</span> <i>.</i>
                                <span>Creative Design</span> <i>.</i>
                                <span>WEb Design</span> <i>.</i>
                                <span>Creative</span> <i>.</i>
                                <span>Design</span> <i>.</i>
                                <span>UX</span> <i>.</i>
                                <span>Web</span> <i>.</i>
                                <span>Development</span> <i>.</i>
                                <span>Creative</span> <i>.</i>
                                <span>Design</span> <i>.</i>
                                <span>UX</span> <i>.</i>
                                <span>Web</span> <i>.</i>
                                <span>Development</span> <i>.</i>
                                <span>Logo</span> <i>.</i>
                                <span>Branding</span> <i>.</i>
                                <span>Innovation</span> <i>.</i>
                                <span>Creative Design</span> <i>.</i>
                                <span>WEb Design</span> <i>.</i>
                                <span>Creative</span> <i>.</i>
                                <span>Design</span> <i>.</i>
                                <span>UX</span> <i>.</i>
                                <span>Web</span> <i>.</i>
                                <span>Development</span> <i>.</i>
                                <span>Creative</span> <i>.</i>
                                <span>Design</span> <i>.</i>
                                <span>UX</span> <i>.</i>
                                <span>Web</span> <i>.</i>
                                <span>Development</span> <i>.</i>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarqueeSectionS2;